import { render, staticRenderFns } from "./ArchivedCRM.vue?vue&type=template&id=0bcd401a&scoped=true&"
import script from "./ArchivedCRM.vue?vue&type=script&lang=js&"
export * from "./ArchivedCRM.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedCRM.vue?vue&type=style&index=0&id=0bcd401a&prod&lang=css&"
import style1 from "./ArchivedCRM.vue?vue&type=style&index=1&id=0bcd401a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcd401a",
  null
  
)

export default component.exports